import { APIProvider } from "@vis.gl/react-google-maps";

interface GoogleMapsApiProviderProps {
  children: React.ReactNode;
}

export function GoogleMapsApiProvider({
  children,
}: GoogleMapsApiProviderProps) {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  if (!apiKey) return <>{children}</>;

  return (
    <APIProvider apiKey={apiKey} libraries={["geometry"]}>
      {children}
    </APIProvider>
  );
}
